// should be a types file? where should we move it?
import { PostalCode } from "Types/api/Person";

export const CARS_TEST_DEALER_UUID = "0f07d5f60e"; // where to store this? appears to be per dealership?

// export const SYSTEM_KEY = "bab566d382992b5ba7e92a99620a95f5da170f90"; // where to best store this
// export const DEALER_UUID = "85164c49c2"; // where to store this? appears to be per dealership?

export const ACCUTRADE_NON_PROD = "https://perseus-consumer-qa.rhcapl.com";
export const ACCUTRADE_PROD = "https://cashoffer.accu-trade.com";
export const ACCUTRADE_KEY_NON_PROD = "33c2fbffb32496375ee49910a41f2f980067bef3";
export const ACCUTRADE_KEY_PROD = "033a03fd227c130b88a3076ab579f8287a9b1993";

export interface AtInbound {
    consumer?: InboundConsumer;
    voi?: VOI;
}

export interface InboundConsumer {
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    postalCode?: PostalCode;
}

export interface OutboundConsumer {
    first_name?: string;
    last_name?: string;
    cell_phone?: string;
    email?: string;
    postal_code?: string;
    phone_verified?: boolean;
    preferred_contact_method?: string;
}

export interface VOI {
    year?: string;
    make?: string;
    model?: string;
    trim?: string;
    vin?: string;
}

export interface ATPostMessageInbound {
    atInbound: AtInbound;
}

export interface ATPostMessageOutbound {
    atOutbound: AtOutbound;
}

export interface AtOutbound {
    newHeight: number;
    priceAdjustment: boolean;
    estimateComplete: boolean;
    initComplete: boolean;
    offerClosed: boolean;
    details: Details;
    pageView: PageName;
    type?: string;
    event?: AtOutboundEvent;
}

export interface AtOutboundEvent {
    eventAction: AtOutboundEventActions;
}

export enum AtOutboundEventActions {
    tradeComplete = "Trade In Complete",
    tradeStart = "Trade In Start",
}

export interface PageName {
    pageName: string;
}

export interface Details {
    offer: string;
    expirationDate: string;
    price: Price;
    vehicle: Vehicle;
    rawData: RawData;
}

export interface Price {
    range: number[];
    offer: number;
}

export interface RawData {
    consumer: OutboundConsumer;
    vehicle_color: VehicleColor;
    vacs: Vac[];
    is_original_owner: string;
    is_liened: string;
    liened_type: string;
    loan_owed_amount: string;
    lease_monthly_payment: string;
    lease_number_payments: string;
    lease_amount_remaining: string;
    has_accident: string;
    insurance_payout_amount: string;
    has_frame_damage: string;
    carfax_has_bad_vhr: string;
    has_external_damage: string;
    external_damage_amount: string;
    front_tire_age: string;
    rear_tire_age: string;
    has_mechanical_issues: string;
    has_mechanical_ac: string;
    has_mechanical_brakes: string;
    has_mechanical_catalytic_converter: string;
    has_mechanical_engine: string;
    has_mechanical_exhaust: string;
    has_mechanical_head_gasket: string;
    has_mechanical_oil_leak: string;
    has_mechanical_sunroof_moonroof: string;
    has_mechanical_suspension: string;
    has_mechanical_transmission: string;
    has_mechanical_other: string;
    mechanical_other_note: string;
    has_warning_lights: string;
    has_warning_lights_abs: string;
    has_warning_lights_srs: string;
    has_warning_lights_battery: string;
    has_warning_lights_brake: string;
    has_warning_lights_engine: string;
    has_warning_lights_tpms: string;
    has_warning_lights_suspension_fault: string;
    has_warning_lights_traction_control: string;
    has_modifications: string;
    has_modifications_exhaust: string;
    has_modifications_performance: string;
    has_modifications_stereo: string;
    has_modifications_spoiler: string;
    has_modifications_sunroof_moonroof: string;
    has_modifications_suspension_lifted: string;
    has_modifications_suspension_lowered: string;
    has_modifications_wheel: string;
    has_aftermarket_tint: string;
    has_odor: string;
    has_other_issues: string;
    is_salvage_title: string;
    is_rebuilt_title: string;
    has_fire_damage: string;
    has_flood_damage: string;
    was_stolen: string;
    other_issues_repair_cost: string;
    plate_number: string;
    plate_state: string;
}

export interface Vac {
    description: string;
    amount: string;
    selected: string;
}

export interface VehicleColor {
    name: string;
    hex_code: string;
}

export interface Vehicle {
    image: string;
    year: number;
    make: string;
    model: string;
    style: string;
    vin: string;
    mileage: number;
}
